
function Switches (){
    return(
        <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" style={{width:"70px",height:"20px",outline:"none"}}></input>
        </div>
    )
}

export default Switches ;